import { useEffect, useState, useContext } from "react";
import { Dropdown, Space, Grid } from "antd";
import PropTypes from "prop-types";
import {
  DownOutlined,
  UserOutlined,
  EditOutlined,
  LogoutOutlined,
  SelectOutlined,
  SolutionOutlined,
  LockOutlined,
  ShopOutlined,
  NotificationOutlined,
  SearchOutlined,
  ApartmentOutlined,
} from "@ant-design/icons";
import { AdminContext } from "../../providers/AdminContext";
import { useNavigate } from "react-router-dom";
import { translate } from "../../locale";
import { versionCode } from "../../core/config";
const { useBreakpoint } = Grid;

const MenuAdmin = ({ onLogout }) => {
  const [username, setUsername] = useState(null);
  const { user, setProfile } = useContext(AdminContext);
  const [isSuper, setIsSuper] = useState(false);
  const [isCoord, setIsCoord] = useState(false);
  const [isSuperOrAdmin, setIsSuperOrAdmin] = useState(false);
  const navigate = useNavigate();
  const screens = useBreakpoint();

  useEffect(() => {
    if (user !== null && user !== undefined) {
      setUsername(user.user.username);
      setIsSuper(user.user.rol === "eira-super-admin");
      setIsCoord(user.user.rol === "eira-company-coordinator");
      setIsSuperOrAdmin(
        user.user.rol === "eira-company-admin" ||
          user.user.rol === "eira-super-admin"
      );
    }
  }, [user]);

  const handleLogout = async () => {
    try {
      localStorage.removeItem("remember_me");
      localStorage.removeItem("accessToken");
      localStorage.removeItem("refreshToken");
      localStorage.removeItem("username");
      sessionStorage.removeItem("remember_me");
      sessionStorage.removeItem("accessToken");
      sessionStorage.removeItem("refreshToken");
      sessionStorage.removeItem("username");
      sessionStorage.removeItem("nextUrl");
      sessionStorage.removeItem("subscriptionHome");
      setProfile(null);

      if (onLogout) {
        onLogout();
      }

      navigate("/auth/login");
    } catch (error) {
      console.log(error);
    }
  };

  const handleClickMenuSettings = (e) => {
    switch (e.key) {
      case "search":
        navigate("/admin/buscar-paciente");
        break;
      case "users":
        navigate("/admin/users");
        break;
      case "companies":
        navigate("/admin/companies");
        break;
      case "subscriptions":
        navigate("/admin/subscriptions");
        break;
      case "protocols":
        navigate("/admin/protocols");
        break;
      case "pills":
        navigate("/admin/pills");
        break;
      case "abtest":
        navigate("/admin/abtest");
        break;
      case "profile":
        navigate("/admin/profile");
        break;
      case "contacts":
        navigate("/admin/contacts");
        break;
      case "logout":
        handleLogout();
        break;
      case "change_password":
        navigate("/admin/change-password");
        break;
      default:
        console.log("e", e.key);
        break;
    }
  };

  const menuItems = (size) => {
    const defaultItems = [
      {
        key: "contacts",
        label: translate("Contactos"),
        icon: <UserOutlined />,
        onClick: handleClickMenuSettings,
      },
      isSuperOrAdmin && {
        key: "companies",
        label: translate("Empresas"),
        icon: <ShopOutlined />,
        onClick: handleClickMenuSettings,
      },
      (isSuperOrAdmin || isCoord) && {
        key: "subscriptions",
        label: translate("Suscripciones"),
        icon: <SelectOutlined />,
        onClick: handleClickMenuSettings,
      },
      isSuper && {
        key: "protocols",
        label: translate("Protocolos"),
        icon: <SolutionOutlined />,
        onClick: handleClickMenuSettings,
      },
      isSuper && {
        key: "pills",
        label: translate("Píldoras"),
        icon: <NotificationOutlined />,
        onClick: handleClickMenuSettings,
      },
      isSuper && {
        key: "abtest",
        label: translate("AB Test"),
        icon: <ApartmentOutlined />,
        onClick: handleClickMenuSettings,
      },
      { type: "divider" },
      {
        key: "profile",
        label: translate("Perfil"),
        icon: <EditOutlined />,
        onClick: handleClickMenuSettings,
      },
      {
        key: "change_password",
        label: translate("Cambiar contraseña"),
        icon: <LockOutlined />,
        onClick: handleClickMenuSettings,
      },
      { type: "divider" },
      {
        key: "logout",
        label: translate("Cerrar sesión"),
        icon: <LogoutOutlined />,
        onClick: handleClickMenuSettings,
      },
      { type: "divider" },
      {
        key: "version_code",
        label: (
          <div
            className="text-center"
            style={{ fontSize: 8 }}
          >{`v${versionCode}`}</div>
        ),
        className: "py-0 !cursor-default",
        disabled: true,
      },
    ];
    const extraItem = {
      key: "search",
      label: translate("Buscar Contacto"),
      icon: <SearchOutlined />,
      onClick: handleClickMenuSettings,
    };

    return size.md === false ? [extraItem, ...defaultItems] : defaultItems;
  };

  return (
    <>
      {!username && (
        <a
          className="mx-0 md:mx-2 text-sm text-white hover:text-black"
          onClick={(e) => {
            e.preventDefault();
            navigate("/auth/login");
          }}
        >
          {translate("Iniciar sesión")}
        </a>
      )}
      {username && (
        <Dropdown menu={{ items: menuItems(screens) }}>
          <a
            className="ant-dropdown-link text-white  hover:text-black"
            onClick={(e) => e.preventDefault()}
          >
            <Space>
              {username ? username : translate("Usuario")} <DownOutlined />
            </Space>
          </a>
        </Dropdown>
      )}
    </>
  );
};

MenuAdmin.propTypes = {
  onLogout: PropTypes.func,
};

export default MenuAdmin;
